// Échelle d'évaluation qualitative (identique à constants.NOTES_SCALE côté
// backend) avec ses couleurs d'affichage.
export const NOTES = [
  { id: "echoue", label: "Échoué", short: "Échoué", cls: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30", dot: "bg-red-500" },
  { id: "difficulte", label: "Réalisé avec difficulté", short: "Difficulté", cls: "bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-500/30", dot: "bg-orange-500" },
  { id: "realise", label: "Réalisé", short: "Réalisé", cls: "bg-sky-500/15 text-sky-700 dark:text-sky-300 border-sky-500/30", dot: "bg-sky-500" },
  { id: "bien", label: "Bien réalisé", short: "Bien", cls: "bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30", dot: "bg-green-500" },
  { id: "tres_bien", label: "Très bien réalisé", short: "Très bien", cls: "bg-emerald-600/15 text-emerald-700 dark:text-emerald-300 border-emerald-600/30", dot: "bg-emerald-600" },
];
export const NOTE_BY_ID = Object.fromEntries(NOTES.map((n) => [n.id, n]));
export const ALL_NOTE_IDS = NOTES.map((n) => n.id);

export function NoteBadge({ note, short = false }) {
  const n = NOTE_BY_ID[note];
  if (!n) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${n.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${n.dot}`} />
      {short ? n.short : n.label}
    </span>
  );
}
